"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeInlineCaseValidationSchema = makeInlineCaseValidationSchema;
exports.CaseInlineCreateBody = CaseInlineCreateBody;
const react_1 = __importStar(require("react"));
const Yup = __importStar(require("yup"));
const react_bootstrap_1 = require("react-bootstrap");
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const FormContext_1 = require("../../../View/Modals/FormContext");
const CaseModalBody_1 = require("./CaseModalBody");
const CaseValidationSchema_1 = require("./CaseValidationSchema");
const ContractsController_1 = require("../../../Contracts/ContractsList/ContractsController");
/**
 * Schemat walidacji dla inline-tworzenia Sprawy w panelu.
 *
 * BRAMKA: `makeCaseValidationSchema` waliduje wyłącznie `name`/`description` (NIE `_parent`
 * ani `_type`), więc sam w sobie nie blokuje zapisu przed wyborem kamienia milowego.
 * Tutaj rozszerzamy go o wymóg `_parent` (Kamień milowy) i `_type` (Typ sprawy), dzięki
 * czemu przycisk "Zapisz" w `InlineCreateDrawer` (disabled gdy `!isValid`) pozostaje
 * zablokowany, dopóki rodzic i typ nie zostaną wybrane.
 */
function makeInlineCaseValidationSchema(isEditing) {
    return (0, CaseValidationSchema_1.makeCaseValidationSchema)(isEditing).shape({
        _parent: Yup.object().nullable().required("Wybierz kamień milowy"),
        _type: Yup.object().nullable().required("Wybierz typ sprawy"),
    });
}
/**
 * Złożone body panelu inline-tworzenia Sprawy (używane przez `InlineCreateDrawer`).
 *
 * Reużywa istniejące komponenty bez ich modyfikacji:
 * - `MilestoneSelector` (z N2) — wybór Kamienia milowego (rodzica Sprawy); zapisuje
 *   wybrany obiekt do pola `_parent` w formularzu,
 * - `CaseModalBody` — niezmieniony formularz Sprawy (typ + nazwa + uwagi).
 *
 * `CaseModalBody` czyta rodzica jako `initialData?._parent || contextData` i na jego
 * podstawie renderuje `CaseTypeSelector` (`milestoneType={_parent._type}`). Dlatego
 * dopiero PO wybraniu Kamienia milowego przekazujemy go do `CaseModalBody` jako
 * `contextData` — to spełnia kontrakt "drawer wstrzykuje Milestone jako _parent".
 *
 * `_contract` (do załadowania listy kamieni) przychodzi przez `additionalProps`.
 */
function CaseInlineCreateBody({ additionalProps }) {
    const { watch } = (0, FormContext_1.useFormContext)();
    const _contract = additionalProps?._contract;
    // Pisma do ofert: rodzicem kamieni jest Oferta, nie Kontrakt (jedno z dwóch, nigdy oba).
    const _offer = additionalProps?._offer;
    const selectedMilestone = watch("_parent");
    // null = jeszcze nieładowane; liczba = wynik ostatniego ładowania dla kontraktu.
    const [milestoneCount, setMilestoneCount] = (0, react_1.useState)(null);
    // `CaseTypeSelector` czyta opcje wprost z `caseTypesRepository.items`, ale sam ich NIE
    // ładuje — w TasksGlobal repo jest wstępnie ładowane na mount. W formularzu pisma nikt go
    // nie ładuje, więc tutaj dociągamy typy spraw, zanim zamontujemy CaseModalBody (inaczej
    // lista "Typ sprawy" jest pusta).
    const [caseTypesReady, setCaseTypesReady] = (0, react_1.useState)(ContractsController_1.caseTypesRepository.items.length > 0);
    (0, react_1.useEffect)(() => {
        let active = true;
        if (ContractsController_1.caseTypesRepository.items.length === 0) {
            ContractsController_1.caseTypesRepository
                .loadItemsFromServerPOST()
                .then(() => active && setCaseTypesReady(true))
                .catch(() => active && setCaseTypesReady(true));
        }
        return () => {
            active = false;
        };
    }, []);
    // Brak kamieni milowych dla kontraktu/oferty ⇒ nie da się utworzyć Sprawy (musi mieć rodzica).
    // Zgodnie z N0: kierujemy do TasksGlobal (inline tworzenie Kamienia jest odroczone).
    const hasNoMilestones = (!!_contract || !!_offer) && milestoneCount === 0;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BussinesObjectSelectors_1.MilestoneSelector, { name: "_parent", _contract: _contract, _offer: _offer, onOptionsLoaded: setMilestoneCount }),
        hasNoMilestones ? (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "mt-2 mb-0 small" },
            _offer ? "Ta oferta" : "Ten kontrakt",
            " nie ma jeszcze kamieni milowych, wi\u0119c nie mo\u017Cna utworzy\u0107 sprawy. Dodaj kamie\u0144 milowy w",
            " ",
            react_1.default.createElement(react_bootstrap_1.Alert.Link, { href: "#/tasksGlobal", target: "_blank", rel: "noopener noreferrer" }, "module Zadania (TasksGlobal)"),
            ", a nast\u0119pnie wr\u00F3\u0107 tutaj.")) : selectedMilestone ? (caseTypesReady ? (react_1.default.createElement(CaseModalBody_1.CaseModalBody, { isEditing: false, contextData: selectedMilestone })) : (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2 mt-2 text-muted small" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { as: "span", animation: "border", size: "sm", role: "status", "aria-hidden": "true" }),
            "\u0141adowanie typ\u00F3w spraw\u2026"))) : (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "mt-2 mb-0 border small text-muted" }, "Wybierz kamie\u0144 milowy, aby okre\u015Bli\u0107 typ i nazw\u0119 sprawy."))));
}
